export enum ENotificationType {
  OrderCreated = 'order_created',
  DeliveryCreated = 'delivery_created',
  SolpedCreated = 'solped_created',
  SupplyOrderCreated = 'supply_order_created',
  EntryPlanCreated = 'entry_plan_created',
  MaterialRequestExpiration = 'material_request_expiration',
  MaterialRequestPreExpiration = 'material_request_pre_expiration',
}

export default ENotificationType;
